import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, ChevronDown, Twitter, UserCircle, Search, Upload, Palette, Cpu, CheckCircle, RefreshCw, Brain, Map, UserSquare, Phone, FolderKanban, Globe, Megaphone, UserPlus, Database, BarChart3, Mic, Star, FileText, Zap, CheckSquare, Building2, Briefcase, GitCompare, Puzzle, BookOpen, FileBarChart, Code, Info, Handshake, Users, Mail, ArrowRight } from 'lucide-react';
export function Nav() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'shadow-lg' : ''}`} data-id="element-474">
      {/* Layer 1: Top Utility Bar */}
      <div className={`bg-[#332B67] text-white overflow-hidden transition-all duration-300 border-b border-[#4a3f8a]/50 shadow-[inset_0_-1px_0_rgba(255,255,255,0.08)] ${isScrolled ? 'h-0 opacity-0' : 'hidden md:block h-[28px] opacity-100'}`} data-id="element-475">
        <div className="max-w-7xl mx-auto px-6 h-full flex items-center justify-between text-xs font-medium" data-id="element-476">
          <div className="flex items-center gap-6" data-id="element-477">
            <Link to="/" className="hover:text-teal transition-colors" data-id="element-478">
              Home
            </Link>
            <Link to="/pricing" className="hover:text-teal transition-colors" data-id="element-479">
              Pricing
            </Link>
            <Link to="/contact" className="hover:text-teal transition-colors" data-id="element-480">
              Contact
            </Link>
          </div>
          <div className="flex items-center gap-6" data-id="element-481">
            <div className="flex items-center gap-4" data-id="element-482">
              <span className="text-white/50" data-id="element-483">Login:</span>
              <a href="https://app.1dash.pro" target="_blank" rel="noopener noreferrer" className="hover:text-teal transition-colors" data-id="element-484">
                1Dash
              </a>
              <a href="https://app.dartai.com" target="_blank" rel="noopener noreferrer" className="hover:text-teal transition-colors" data-id="element-485">
                Dart AI
              </a>
              <a href="https://thinktank.mindstream.ing" target="_blank" rel="noopener noreferrer" className="hover:text-teal transition-colors" data-id="element-486">
                ThinkTank
              </a>
              <a href="https://members.mindstream.ing" target="_blank" rel="noopener noreferrer" className="hover:text-teal transition-colors" data-id="element-487">
                Community
              </a>
            </div>
            <div className="w-px h-3 bg-white/20" data-id="element-488"></div>
            <a href="#" className="flex items-center gap-1 hover:text-teal transition-colors" data-id="element-489">
              <Twitter size={12} data-id="element-490" /> Follow us
            </a>
          </div>
        </div>
      </div>

      {/* Layer 2: Main Navigation */}
      <div className="bg-white border-b border-gray-200 shadow-sm" data-id="element-491">
        <div className="max-w-7xl mx-auto px-6 flex items-center justify-between h-[80px]" data-id="element-492">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 md:gap-3 shrink-0" data-id="element-493">
            <img src="https://cdn.magicpatterns.com/uploads/dWXrt9xNFh6bNpGwsjysP6/ChatGPT_Image_Mar_20,_2026,_02_15_39_PM.png" alt="MINDStream.ing icon" className="h-10 w-10 md:h-12 md:w-12 rounded-lg" data-id="element-494" />
            <span className="font-poppins text-xl md:text-2xl font-extrabold tracking-tight" data-id="element-495">
              <span style={{
              color: '#3D32AE'
            }} data-id="element-496">
                MIND
              </span>
              <span className="text-teal font-bold" data-id="element-497">stream</span>
              <span style={{
              color: '#3D32AE'
            }} className="italic font-bold" data-id="element-498">
                .ing
              </span>
            </span>
          </Link>

          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center gap-8" data-id="element-499">
            {/* ═══ HOW IT WORKS MEGA MENU ═══ */}
            <div className="relative group cursor-pointer py-8" data-id="element-500">
              <span className="flex items-center gap-1 text-sm font-medium text-gray-700 hover:text-teal transition-colors" data-id="element-501">
                How It Works <ChevronDown size={16} data-id="element-502" />
              </span>
              <div className="absolute top-full left-0 w-[520px] bg-white border border-gray-100 rounded-xl shadow-2xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all translate-y-2 group-hover:translate-y-0" data-id="element-503">
                <div className="p-6 grid grid-cols-2 gap-3" data-id="element-504">
                  <Link to="/how-it-works/meet-mr" className="flex items-start gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-505">
                    <div className="w-9 h-9 rounded-lg bg-purple/10 flex items-center justify-center shrink-0" data-id="element-506">
                      <UserCircle size={18} className="text-purple" data-id="element-507" />
                    </div>
                    <div data-id="element-508">
                      <div className="text-sm font-semibold text-gray-800" data-id="element-509">
                        1. Meet MR
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-510">
                        Quick intro call to get started
                      </div>
                    </div>
                  </Link>
                  <Link to="/how-it-works/business-deep-dive" className="flex items-start gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-511">
                    <div className="w-9 h-9 rounded-lg bg-purple/10 flex items-center justify-center shrink-0" data-id="element-512">
                      <Search size={18} className="text-purple" data-id="element-513" />
                    </div>
                    <div data-id="element-514">
                      <div className="text-sm font-semibold text-gray-800" data-id="element-515">
                        2. Business Deep Dive
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-516">
                        We learn how your business runs
                      </div>
                    </div>
                  </Link>
                  <Link to="/how-it-works/intake-upload" className="flex items-start gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-517">
                    <div className="w-9 h-9 rounded-lg bg-purple/10 flex items-center justify-center shrink-0" data-id="element-518">
                      <Upload size={18} className="text-purple" data-id="element-519" />
                    </div>
                    <div data-id="element-520">
                      <div className="text-sm font-semibold text-gray-800" data-id="element-521">
                        3. Intake & Upload
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-522">
                        Bring your tools & data together
                      </div>
                    </div>
                  </Link>
                  <Link to="/how-it-works/brand-persona" className="flex items-start gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-523">
                    <div className="w-9 h-9 rounded-lg bg-purple/10 flex items-center justify-center shrink-0" data-id="element-524">
                      <Palette size={18} className="text-purple" data-id="element-525" />
                    </div>
                    <div data-id="element-526">
                      <div className="text-sm font-semibold text-gray-800" data-id="element-527">
                        4. Brand Persona
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-528">
                        Create your unique brand voice
                      </div>
                    </div>
                  </Link>
                  <Link to="/how-it-works/create-agents" className="flex items-start gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-529">
                    <div className="w-9 h-9 rounded-lg bg-purple/10 flex items-center justify-center shrink-0" data-id="element-530">
                      <Cpu size={18} className="text-purple" data-id="element-531" />
                    </div>
                    <div data-id="element-532">
                      <div className="text-sm font-semibold text-gray-800" data-id="element-533">
                        5. Create Agents
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-534">
                        Your AI agents go live
                      </div>
                    </div>
                  </Link>
                  <Link to="/how-it-works/review-process" className="flex items-start gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-535">
                    <div className="w-9 h-9 rounded-lg bg-purple/10 flex items-center justify-center shrink-0" data-id="element-536">
                      <CheckCircle size={18} className="text-purple" data-id="element-537" />
                    </div>
                    <div data-id="element-538">
                      <div className="text-sm font-semibold text-gray-800" data-id="element-539">
                        6. Review Process
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-540">
                        Make sure everything works
                      </div>
                    </div>
                  </Link>
                  <Link to="/how-it-works/revamp-repeat" className="flex items-start gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors col-span-2" data-id="element-541">
                    <div className="w-9 h-9 rounded-lg bg-purple/10 flex items-center justify-center shrink-0" data-id="element-542">
                      <RefreshCw size={18} className="text-purple" data-id="element-543" />
                    </div>
                    <div data-id="element-544">
                      <div className="text-sm font-semibold text-gray-800" data-id="element-545">
                        7. Revamp & Repeat
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-546">
                        Optimize and grow continuously
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="bg-gray-50 p-3 rounded-b-xl border-t border-gray-100 text-center" data-id="element-547">
                  <Link to="/how-it-works" className="text-xs font-semibold text-teal hover:text-navy-dark transition-colors inline-flex items-center gap-1" data-id="element-548">
                    View Full Process <ArrowRight size={12} data-id="element-549" />
                  </Link>
                </div>
              </div>
            </div>

            {/* ═══ FEATURES MEGA MENU ═══ */}
            <div className="relative group cursor-pointer py-8" data-id="element-550">
              <span className="flex items-center gap-1 text-sm font-medium text-gray-700 hover:text-teal transition-colors" data-id="element-551">
                Features <ChevronDown size={16} data-id="element-552" />
              </span>
              <div className="absolute top-full left-1/2 -translate-x-1/2 w-[900px] bg-white border border-gray-100 rounded-xl shadow-2xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all translate-y-2 group-hover:translate-y-0" data-id="element-553">
                <div className="p-6 grid grid-cols-4 gap-6" data-id="element-554">
                  {/* Column 1: AI Brain */}
                  <div data-id="element-555">
                    <h3 className="font-poppins font-semibold text-teal mb-4 text-xs uppercase tracking-wider" data-id="element-556">
                      Your AI Brain
                    </h3>
                    <div className="flex flex-col gap-1" data-id="element-557">
                      <Link to="/think-tank" className="flex items-start gap-3 p-2 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-558">
                        <div className="w-8 h-8 rounded-lg bg-teal/10 flex items-center justify-center shrink-0 mt-0.5" data-id="element-559">
                          <Brain size={16} className="text-teal" data-id="element-560" />
                        </div>
                        <div data-id="element-561">
                          <div className="text-sm font-semibold text-gray-800" data-id="element-562">
                            ThinkTank
                          </div>
                          <div className="text-xs text-gray-500" data-id="element-563">
                            AI-powered strategy hub
                          </div>
                        </div>
                      </Link>
                      <Link to="/live-mind-maps" className="flex items-start gap-3 p-2 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-564">
                        <div className="w-8 h-8 rounded-lg bg-teal/10 flex items-center justify-center shrink-0 mt-0.5" data-id="element-565">
                          <Map size={16} className="text-teal" data-id="element-566" />
                        </div>
                        <div data-id="element-567">
                          <div className="text-sm font-semibold text-gray-800" data-id="element-568">
                            Live Mind Maps
                          </div>
                          <div className="text-xs text-gray-500" data-id="element-569">
                            Visual business intelligence
                          </div>
                        </div>
                      </Link>
                      <Link to="/persona-builder" className="flex items-start gap-3 p-2 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-570">
                        <div className="w-8 h-8 rounded-lg bg-teal/10 flex items-center justify-center shrink-0 mt-0.5" data-id="element-571">
                          <UserSquare size={16} className="text-teal" data-id="element-572" />
                        </div>
                        <div data-id="element-573">
                          <div className="text-sm font-semibold text-gray-800" data-id="element-574">
                            Persona Builder
                          </div>
                          <div className="text-xs text-gray-500" data-id="element-575">
                            Define your brand identity
                          </div>
                        </div>
                      </Link>
                      <Link to="/dedicated-line" className="flex items-start gap-3 p-2 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-576">
                        <div className="w-8 h-8 rounded-lg bg-teal/10 flex items-center justify-center shrink-0 mt-0.5" data-id="element-577">
                          <Phone size={16} className="text-teal" data-id="element-578" />
                        </div>
                        <div data-id="element-579">
                          <div className="text-sm font-semibold text-gray-800" data-id="element-580">
                            Dedicated Line
                          </div>
                          <div className="text-xs text-gray-500" data-id="element-581">
                            Your own AI phone number
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>
                  {/* Column 2: Your Business */}
                  <div data-id="element-582">
                    <h3 className="font-poppins font-semibold text-teal mb-4 text-xs uppercase tracking-wider" data-id="element-583">
                      Your Business
                    </h3>
                    <div className="flex flex-col gap-1" data-id="element-584">
                      <Link to="/project-manager" className="flex items-start gap-3 p-2 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-585">
                        <div className="w-8 h-8 rounded-lg bg-teal/10 flex items-center justify-center shrink-0 mt-0.5" data-id="element-586">
                          <FolderKanban size={16} className="text-teal" data-id="element-587" />
                        </div>
                        <div data-id="element-588">
                          <div className="text-sm font-semibold text-gray-800" data-id="element-589">
                            Project Manager
                          </div>
                          <div className="text-xs text-gray-500" data-id="element-590">
                            Tasks that manage themselves
                          </div>
                        </div>
                      </Link>
                      <Link to="/self-building-website" className="flex items-start gap-3 p-2 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-591">
                        <div className="w-8 h-8 rounded-lg bg-teal/10 flex items-center justify-center shrink-0 mt-0.5" data-id="element-592">
                          <Globe size={16} className="text-teal" data-id="element-593" />
                        </div>
                        <div data-id="element-594">
                          <div className="text-sm font-semibold text-gray-800" data-id="element-595">
                            Self-Building Website
                          </div>
                          <div className="text-xs text-gray-500" data-id="element-596">
                            Sites that build & update
                          </div>
                        </div>
                      </Link>
                      <Link to="/self-running-marketing" className="flex items-start gap-3 p-2 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-597">
                        <div className="w-8 h-8 rounded-lg bg-teal/10 flex items-center justify-center shrink-0 mt-0.5" data-id="element-598">
                          <Megaphone size={16} className="text-teal" data-id="element-599" />
                        </div>
                        <div data-id="element-600">
                          <div className="text-sm font-semibold text-gray-800" data-id="element-601">
                            Self-Running Marketing
                          </div>
                          <div className="text-xs text-gray-500" data-id="element-602">
                            Marketing on autopilot
                          </div>
                        </div>
                      </Link>
                      <Link to="/onboarding-agents" className="flex items-start gap-3 p-2 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-603">
                        <div className="w-8 h-8 rounded-lg bg-teal/10 flex items-center justify-center shrink-0 mt-0.5" data-id="element-604">
                          <UserPlus size={16} className="text-teal" data-id="element-605" />
                        </div>
                        <div data-id="element-606">
                          <div className="text-sm font-semibold text-gray-800" data-id="element-607">
                            Onboarding Agents
                          </div>
                          <div className="text-xs text-gray-500" data-id="element-608">
                            Automate client onboarding
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>
                  {/* Column 3: Your Growth */}
                  <div data-id="element-609">
                    <h3 className="font-poppins font-semibold text-teal mb-4 text-xs uppercase tracking-wider" data-id="element-610">
                      Your Growth
                    </h3>
                    <div className="flex flex-col gap-1" data-id="element-611">
                      <Link to="/self-managing-crm" className="flex items-start gap-3 p-2 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-612">
                        <div className="w-8 h-8 rounded-lg bg-teal/10 flex items-center justify-center shrink-0 mt-0.5" data-id="element-613">
                          <Database size={16} className="text-teal" data-id="element-614" />
                        </div>
                        <div data-id="element-615">
                          <div className="text-sm font-semibold text-gray-800" data-id="element-616">
                            Self-Managing CRM
                          </div>
                          <div className="text-xs text-gray-500" data-id="element-617">
                            CRM that runs itself
                          </div>
                        </div>
                      </Link>
                      <Link to="/advanced-analytics" className="flex items-start gap-3 p-2 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-618">
                        <div className="w-8 h-8 rounded-lg bg-teal/10 flex items-center justify-center shrink-0 mt-0.5" data-id="element-619">
                          <BarChart3 size={16} className="text-teal" data-id="element-620" />
                        </div>
                        <div data-id="element-621">
                          <div className="text-sm font-semibold text-gray-800" data-id="element-622">
                            Advanced Analytics
                          </div>
                          <div className="text-xs text-gray-500" data-id="element-623">
                            Deep insights & reporting
                          </div>
                        </div>
                      </Link>
                      <Link to="/voice-agents" className="flex items-start gap-3 p-2 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-624">
                        <div className="w-8 h-8 rounded-lg bg-teal/10 flex items-center justify-center shrink-0 mt-0.5" data-id="element-625">
                          <Mic size={16} className="text-teal" data-id="element-626" />
                        </div>
                        <div data-id="element-627">
                          <div className="text-sm font-semibold text-gray-800" data-id="element-628">
                            Voice Agents
                          </div>
                          <div className="text-xs text-gray-500" data-id="element-629">
                            AI that talks for you
                          </div>
                        </div>
                      </Link>
                      <Link to="/reputation-manager" className="flex items-start gap-3 p-2 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-630">
                        <div className="w-8 h-8 rounded-lg bg-teal/10 flex items-center justify-center shrink-0 mt-0.5" data-id="element-631">
                          <Star size={16} className="text-teal" data-id="element-632" />
                        </div>
                        <div data-id="element-633">
                          <div className="text-sm font-semibold text-gray-800" data-id="element-634">
                            Reputation Manager
                          </div>
                          <div className="text-xs text-gray-500" data-id="element-635">
                            Protect your online image
                          </div>
                        </div>
                      </Link>
                      <Link to="/document-generator" className="flex items-start gap-3 p-2 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-636">
                        <div className="w-8 h-8 rounded-lg bg-teal/10 flex items-center justify-center shrink-0 mt-0.5" data-id="element-637">
                          <FileText size={16} className="text-teal" data-id="element-638" />
                        </div>
                        <div data-id="element-639">
                          <div className="text-sm font-semibold text-gray-800" data-id="element-640">
                            Document Generator
                          </div>
                          <div className="text-xs text-gray-500" data-id="element-641">
                            Auto-create branded docs
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>
                  {/* Column 4: Promo */}
                  <div className="bg-gradient-to-br from-purple to-[#852FF4] rounded-xl p-5 flex flex-col justify-between text-white" data-id="element-642">
                    <div data-id="element-643">
                      <div className="text-lg font-poppins font-bold mb-2" data-id="element-644">
                        Explore All Features
                      </div>
                      <p className="text-sm text-white/80 mb-4" data-id="element-645">
                        See everything MR can do for your business — from AI
                        brains to full automation.
                      </p>
                    </div>
                    <Link to="/features" className="bg-white text-purple font-semibold text-sm px-4 py-2 rounded-lg text-center hover:bg-white/90 transition-colors" data-id="element-646">
                      View All Features
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            {/* ═══ SOLUTIONS MEGA MENU ═══ */}
            <div className="relative group cursor-pointer py-8" data-id="element-647">
              <span className="flex items-center gap-1 text-sm font-medium text-gray-700 hover:text-teal transition-colors" data-id="element-648">
                Solutions <ChevronDown size={16} data-id="element-649" />
              </span>
              <div className="absolute top-full left-0 w-[400px] bg-white border border-gray-100 rounded-xl shadow-2xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all translate-y-2 group-hover:translate-y-0" data-id="element-650">
                <div className="p-4 flex flex-col gap-1" data-id="element-651">
                  <Link to="/business-automation-systems" className="flex items-start gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-652">
                    <div className="w-9 h-9 rounded-lg bg-teal/10 flex items-center justify-center shrink-0" data-id="element-653">
                      <Zap size={18} className="text-teal" data-id="element-654" />
                    </div>
                    <div data-id="element-655">
                      <div className="text-sm font-semibold text-gray-800" data-id="element-656">
                        Business Automation
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-657">
                        End-to-end systems that work for you
                      </div>
                    </div>
                  </Link>
                  <Link to="/business-tasks-automated" className="flex items-start gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-658">
                    <div className="w-9 h-9 rounded-lg bg-teal/10 flex items-center justify-center shrink-0" data-id="element-659">
                      <CheckSquare size={18} className="text-teal" data-id="element-660" />
                    </div>
                    <div data-id="element-661">
                      <div className="text-sm font-semibold text-gray-800" data-id="element-662">
                        Tasks Automated
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-663">
                        Every repetitive task handled by AI
                      </div>
                    </div>
                  </Link>
                  <Link to="/industries" className="flex items-start gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-664">
                    <div className="w-9 h-9 rounded-lg bg-teal/10 flex items-center justify-center shrink-0" data-id="element-665">
                      <Building2 size={18} className="text-teal" data-id="element-666" />
                    </div>
                    <div data-id="element-667">
                      <div className="text-sm font-semibold text-gray-800" data-id="element-668">
                        Industries
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-669">
                        Solutions tailored to your industry
                      </div>
                    </div>
                  </Link>
                  <Link to="/enterprise" className="flex items-start gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-670">
                    <div className="w-9 h-9 rounded-lg bg-teal/10 flex items-center justify-center shrink-0" data-id="element-671">
                      <Briefcase size={18} className="text-teal" data-id="element-672" />
                    </div>
                    <div data-id="element-673">
                      <div className="text-sm font-semibold text-gray-800" data-id="element-674">
                        Enterprise
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-675">
                        Scale AI across your organization
                      </div>
                    </div>
                  </Link>
                  <Link to="/vs" className="flex items-start gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-676">
                    <div className="w-9 h-9 rounded-lg bg-teal/10 flex items-center justify-center shrink-0" data-id="element-677">
                      <GitCompare size={18} className="text-teal" data-id="element-678" />
                    </div>
                    <div data-id="element-679">
                      <div className="text-sm font-semibold text-gray-800" data-id="element-680">
                        Compare Competitors
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-681">
                        See how MR stacks up
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
            </div>

            {/* ═══ RESOURCES MEGA MENU ═══ */}
            <div className="relative group cursor-pointer py-8" data-id="element-682">
              <span className="flex items-center gap-1 text-sm font-medium text-gray-700 hover:text-teal transition-colors" data-id="element-683">
                Resources <ChevronDown size={16} data-id="element-684" />
              </span>
              <div className="absolute top-full left-0 w-[400px] bg-white border border-gray-100 rounded-xl shadow-2xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all translate-y-2 group-hover:translate-y-0" data-id="element-685">
                <div className="p-4 flex flex-col gap-1" data-id="element-686">
                  <Link to="/integrations" className="flex items-start gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-687">
                    <div className="w-9 h-9 rounded-lg bg-purple/10 flex items-center justify-center shrink-0" data-id="element-688">
                      <Puzzle size={18} className="text-purple" data-id="element-689" />
                    </div>
                    <div data-id="element-690">
                      <div className="text-sm font-semibold text-gray-800" data-id="element-691">
                        Integrations
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-692">
                        90+ tools MR connects to
                      </div>
                    </div>
                  </Link>
                  <Link to="/blog" className="flex items-start gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-693">
                    <div className="w-9 h-9 rounded-lg bg-purple/10 flex items-center justify-center shrink-0" data-id="element-694">
                      <BookOpen size={18} className="text-purple" data-id="element-695" />
                    </div>
                    <div data-id="element-696">
                      <div className="text-sm font-semibold text-gray-800" data-id="element-697">
                        Blog
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-698">
                        Tips, updates & AI insights
                      </div>
                    </div>
                  </Link>
                  <Link to="/case-studies" className="flex items-start gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-699">
                    <div className="w-9 h-9 rounded-lg bg-purple/10 flex items-center justify-center shrink-0" data-id="element-700">
                      <FileBarChart size={18} className="text-purple" data-id="element-701" />
                    </div>
                    <div data-id="element-702">
                      <div className="text-sm font-semibold text-gray-800" data-id="element-703">
                        Case Studies
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-704">
                        Real results from real businesses
                      </div>
                    </div>
                  </Link>
                  <a href="https://docs.mindstream.ing" className="flex items-start gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-705">
                    <div className="w-9 h-9 rounded-lg bg-purple/10 flex items-center justify-center shrink-0" data-id="element-706">
                      <Code size={18} className="text-purple" data-id="element-707" />
                    </div>
                    <div data-id="element-708">
                      <div className="text-sm font-semibold text-gray-800" data-id="element-709">
                        Documentation
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-710">
                        Guides & technical reference
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>

            {/* ═══ COMPANY MEGA MENU ═══ */}
            <div className="relative group cursor-pointer py-8" data-id="element-711">
              <span className="flex items-center gap-1 text-sm font-medium text-gray-700 hover:text-teal transition-colors" data-id="element-712">
                Company <ChevronDown size={16} data-id="element-713" />
              </span>
              <div className="absolute top-full right-0 w-[400px] bg-white border border-gray-100 rounded-xl shadow-2xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all translate-y-2 group-hover:translate-y-0" data-id="element-714">
                <div className="p-4 flex flex-col gap-1" data-id="element-715">
                  <Link to="/about" className="flex items-start gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-716">
                    <div className="w-9 h-9 rounded-lg bg-teal/10 flex items-center justify-center shrink-0" data-id="element-717">
                      <Info size={18} className="text-teal" data-id="element-718" />
                    </div>
                    <div data-id="element-719">
                      <div className="text-sm font-semibold text-gray-800" data-id="element-720">
                        About
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-721">
                        Our story and mission
                      </div>
                    </div>
                  </Link>
                  <Link to="/partners" className="flex items-start gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-722">
                    <div className="w-9 h-9 rounded-lg bg-teal/10 flex items-center justify-center shrink-0" data-id="element-723">
                      <Handshake size={18} className="text-teal" data-id="element-724" />
                    </div>
                    <div data-id="element-725">
                      <div className="text-sm font-semibold text-gray-800" data-id="element-726">
                        Partners
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-727">
                        White-label & reseller program
                      </div>
                    </div>
                  </Link>
                  <Link to="/community" className="flex items-start gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-728">
                    <div className="w-9 h-9 rounded-lg bg-teal/10 flex items-center justify-center shrink-0" data-id="element-729">
                      <Users size={18} className="text-teal" data-id="element-730" />
                    </div>
                    <div data-id="element-731">
                      <div className="text-sm font-semibold text-gray-800" data-id="element-732">
                        Community
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-733">
                        Join the MR community
                      </div>
                    </div>
                  </Link>
                  <Link to="/contact" className="flex items-start gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-734">
                    <div className="w-9 h-9 rounded-lg bg-teal/10 flex items-center justify-center shrink-0" data-id="element-735">
                      <Mail size={18} className="text-teal" data-id="element-736" />
                    </div>
                    <div data-id="element-737">
                      <div className="text-sm font-semibold text-gray-800" data-id="element-738">
                        Contact
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-739">
                        Get in touch with our team
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* Right Actions */}
          <div className="hidden lg:flex items-center gap-6" data-id="element-740">
            <Link to="/contact" className="btn-primary py-2.5 px-6 text-sm" data-id="element-741">
              Talk to MR
            </Link>
          </div>

          {/* Mobile Toggle */}
          <button className="lg:hidden text-navy-dark" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-742">
            {isMobileMenuOpen ? <X size={24} data-id="element-743" /> : <Menu size={24} data-id="element-744" />}
          </button>
        </div>
      </div>

      {/* Layer 3: Bottom Category Bar */}
      <div className="bg-[#0785B7] text-white h-[32px] shadow-[inset_0_1px_0_rgba(255,255,255,0.15),inset_0_-1px_0_rgba(0,0,0,0.15),0_2px_6px_rgba(0,0,0,0.1)] overflow-hidden" data-id="element-745">
        {/* Desktop: static centered */}
        <div className="hidden md:flex max-w-7xl mx-auto px-6 h-full items-center justify-center gap-8 text-sm font-semibold tracking-wide whitespace-nowrap" data-id="element-746">
          <Link to="/self-building-website" className="hover:underline underline-offset-4 transition-all whitespace-nowrap" data-id="element-747">
            🌐 Self-Building Websites
          </Link>
          <span className="text-white/30" data-id="element-748">|</span>
          <Link to="/self-managing-crm" className="hover:underline underline-offset-4 transition-all whitespace-nowrap" data-id="element-749">
            🤖 Self-Running CRM
          </Link>
          <span className="text-white/30" data-id="element-750">|</span>
          <Link to="/project-manager" className="hover:underline underline-offset-4 transition-all whitespace-nowrap" data-id="element-751">
            📋 Self-Managing Projects
          </Link>
          <span className="text-white/30" data-id="element-752">|</span>
          <Link to="/self-running-marketing" className="hover:underline underline-offset-4 transition-all whitespace-nowrap" data-id="element-753">
            📣 Self-Running Marketing
          </Link>
          <span className="text-white/30" data-id="element-754">|</span>
          <Link to="/team-of-20" className="hover:underline underline-offset-4 transition-all whitespace-nowrap" data-id="element-755">
            👥 Meet Your Team of 20
          </Link>
        </div>
        {/* Mobile: auto-scrolling marquee */}
        <div className="md:hidden h-full flex items-center" data-id="element-756">
          <div className="animate-marquee-teal flex items-center gap-6 text-sm font-semibold tracking-wide whitespace-nowrap" data-id="element-757">
            <Link to="/self-building-website" className="whitespace-nowrap" data-id="element-758">
              🌐 Self-Building Websites
            </Link>
            <span className="text-white/30" data-id="element-759">|</span>
            <Link to="/self-managing-crm" className="whitespace-nowrap" data-id="element-760">
              🤖 Self-Running CRM
            </Link>
            <span className="text-white/30" data-id="element-761">|</span>
            <Link to="/project-manager" className="whitespace-nowrap" data-id="element-762">
              📋 Self-Managing Projects
            </Link>
            <span className="text-white/30" data-id="element-763">|</span>
            <Link to="/self-running-marketing" className="whitespace-nowrap" data-id="element-764">
              📣 Self-Running Marketing
            </Link>
            <span className="text-white/30" data-id="element-765">|</span>
            <Link to="/team-of-20" className="whitespace-nowrap" data-id="element-766">
              👥 Meet Your Team of 20
            </Link>
            <span className="text-white/30 mx-4" data-id="element-767">|</span>
            <Link to="/self-building-website" className="whitespace-nowrap" data-id="element-768">
              🌐 Self-Building Websites
            </Link>
            <span className="text-white/30" data-id="element-769">|</span>
            <Link to="/self-managing-crm" className="whitespace-nowrap" data-id="element-770">
              🤖 Self-Running CRM
            </Link>
            <span className="text-white/30" data-id="element-771">|</span>
            <Link to="/project-manager" className="whitespace-nowrap" data-id="element-772">
              📋 Self-Managing Projects
            </Link>
            <span className="text-white/30" data-id="element-773">|</span>
            <Link to="/self-running-marketing" className="whitespace-nowrap" data-id="element-774">
              📣 Self-Running Marketing
            </Link>
            <span className="text-white/30" data-id="element-775">|</span>
            <Link to="/team-of-20" className="whitespace-nowrap" data-id="element-776">
              👥 Meet Your Team of 20
            </Link>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="lg:hidden absolute top-full left-0 right-0 bg-white border-b-2 border-teal shadow-2xl overflow-y-auto max-h-[calc(100vh-80px)]" data-id="element-777">
          <div className="p-6 flex flex-col gap-6" data-id="element-778">
            <div className="flex flex-col gap-4" data-id="element-779">
              <div className="text-xs font-bold text-teal uppercase tracking-wider" data-id="element-780">
                How It Works
              </div>
              <Link to="/how-it-works/meet-mr" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-781">
                1. Meet MR
              </Link>
              <Link to="/how-it-works/business-deep-dive" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-782">
                2. Business Deep Dive
              </Link>
              <Link to="/how-it-works/intake-upload" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-783">
                3. Intake/Upload All Data
              </Link>
              <Link to="/how-it-works/brand-persona" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-784">
                4. Create Brand Persona
              </Link>
              <Link to="/how-it-works/create-agents" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-785">
                5. Create & Implement Agents
              </Link>
              <Link to="/how-it-works/review-process" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-786">
                6. Review The Process
              </Link>
              <Link to="/how-it-works/revamp-repeat" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-787">
                7. Revamp & Repeat
              </Link>
              <Link to="/how-it-works" className="text-sm font-semibold text-teal hover:text-navy-dark mt-2" onClick={() => setIsMobileMenuOpen(false)} data-id="element-788">
                View Full Process →
              </Link>
            </div>

            <div className="flex flex-col gap-4" data-id="element-789">
              <div className="text-xs font-bold text-teal uppercase tracking-wider" data-id="element-790">
                Features
              </div>
              <Link to="/think-tank" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-791">
                ThinkTank
              </Link>
              <Link to="/live-mind-maps" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-792">
                Live Mind Maps
              </Link>
              <Link to="/persona-builder" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-793">
                Persona Builder
              </Link>
              <Link to="/dedicated-line" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-794">
                Dedicated Line
              </Link>
              <Link to="/project-manager" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-795">
                Project Manager
              </Link>
              <Link to="/self-building-website" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-796">
                Self-Building Website
              </Link>
              <Link to="/self-running-marketing" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-797">
                Self-Running Marketing
              </Link>
              <Link to="/onboarding-agents" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-798">
                Onboarding Agents
              </Link>
              <Link to="/self-managing-crm" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-799">
                Self-Managing CRM
              </Link>
              <Link to="/advanced-analytics" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-800">
                Advanced Analytics
              </Link>
              <Link to="/voice-agents" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-801">
                Voice Agents
              </Link>
              <Link to="/reputation-manager" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-802">
                Reputation Manager
              </Link>
              <Link to="/document-generator" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-803">
                Document Generator
              </Link>
            </div>

            <div className="flex flex-col gap-4" data-id="element-804">
              <div className="text-xs font-bold text-teal uppercase tracking-wider" data-id="element-805">
                Solutions
              </div>
              <Link to="/business-automation-systems" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-806">
                Business Automation Systems
              </Link>
              <Link to="/business-tasks-automated" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-807">
                Business Tasks Automated
              </Link>
              <Link to="/industries" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-808">
                Industries
              </Link>
              <Link to="/enterprise" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-809">
                Enterprise
              </Link>
              <Link to="/vs" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-810">
                Compare Competitors
              </Link>
            </div>

            <div className="flex flex-col gap-4" data-id="element-811">
              <div className="text-xs font-bold text-teal uppercase tracking-wider" data-id="element-812">
                Resources
              </div>
              <Link to="/integrations" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-813">
                Integrations
              </Link>
              <Link to="/blog" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-814">
                Blog
              </Link>
              <Link to="/case-studies" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-815">
                Case Studies
              </Link>
              <a href="https://docs.mindstream.ing" className="text-sm text-gray-600 hover:text-navy-dark" data-id="element-816">
                Documentation
              </a>
            </div>

            <div className="flex flex-col gap-4" data-id="element-817">
              <div className="text-xs font-bold text-teal uppercase tracking-wider" data-id="element-818">
                Company
              </div>
              <Link to="/about" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-819">
                About
              </Link>
              <Link to="/partners" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-820">
                Partners
              </Link>
              <Link to="/community" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-821">
                Community
              </Link>
              <Link to="/contact" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-822">
                Contact
              </Link>
            </div>

            <div className="flex flex-col gap-4" data-id="element-823">
              <div className="text-xs font-bold text-teal uppercase tracking-wider" data-id="element-824">
                Login
              </div>
              <a href="https://app.1dash.pro" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-600 hover:text-navy-dark" data-id="element-825">
                1Dash
              </a>
              <a href="https://app.dartai.com" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-600 hover:text-navy-dark" data-id="element-826">
                Dart AI
              </a>
              <a href="https://thinktank.mindstream.ing" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-600 hover:text-navy-dark" data-id="element-827">
                ThinkTank
              </a>
              <a href="https://members.mindstream.ing" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-600 hover:text-navy-dark" data-id="element-828">
                Community
              </a>
            </div>

            <Link to="/contact" className="btn-primary w-full mt-4 text-center" onClick={() => setIsMobileMenuOpen(false)} data-id="element-829">
              Talk to MR
            </Link>
          </div>
        </div>}
    </nav>;
}